import api from '../utils/baseUrl';

class PromoterService {
    async getBestPromoters(filters: {
        userType?: string;
        search?: string;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
    } = {}) {
        try {
            const response = await api.get('/api/promoters/best', {params: filters});
            return response.data ?? {};
        } catch (error) {
            console.error('Error fetching best promoters:', error);
            return [];
        }
    }

    async becomePromoter() {
        return await api.post('/api/promoters/become');
    }

    async getPromoter(promoterId: string) {
        try {
            const response = await api.get(`/api/promoters/${promoterId}`);
            return response.data ?? {};
        } catch (error) {
            console.error('Error fetching promoter data:', error);
            return [];
        }
    }

    async getPromoterCampaignLinks(promoterId: string, filters: {
        isActive?: boolean;
        search?: string;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
    } = {}) {
        try {
            const response = await api.get(`api/promoters/${promoterId}/campaignLinks`, {params: filters});
            return Array.isArray(response.data.campaignLinks) ? response.data.campaignLinks : [];
        } catch (error) {
            console.error('Error fetching campaign links:', error);
            return [];
        }
    }

    async blockPromoter(promoterId: string, payload: {
        reason: string;
        reasonMessage: string;
    }) {
        return await api.post(`/api/promoters/${promoterId}/block`, payload);
    }
}

export default new PromoterService();